export const ONBOARDING_COMPLETED_URL_PARAMETER = 'onboarding-completed';
